import { TextField } from "@mui/material";
import React, { FC } from "react";
import { NumericFormat } from 'react-number-format';
import { InputParameters } from "../InputParameters";

interface NumberFormatCustomProps {
    inputRef: (instance: HTMLInputElement | null) => void;
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
    decimal?: number;
    maxLength?: number;
    minLength?: number;
    symbol?: string;
    sufix?: string;
    allowNegative?: boolean;
    showThousandSeparator?: boolean;
}

const NumberFormatCustom = (props: NumberFormatCustomProps) => {
    const { inputRef, allowNegative, onChange, symbol, decimal, sufix, maxLength, minLength, showThousandSeparator = false, ...other } = props

    return (<NumericFormat
        {...other}
        allowNegative={allowNegative}
        getInputRef={inputRef}
        onValueChange={(values) => {
            onChange({
                target: {
                    name: props.name,
                    value: values.value
                }
            })
        }}
        decimalScale={decimal}
        fixedDecimalScale
        valueIsNumericString={true}
        thousandSeparator={showThousandSeparator ? "." : false}
        decimalSeparator=","
        prefix={symbol ? symbol + " " : ""}
        maxLength={maxLength}
        minLength={minLength}
    />)
}

interface InputDecimal3Properties {
    allowNegative?: boolean;
    maxLength?: number;
    minLength?: number;
    decimal?: number;
    placeholder?: string;
    showThousandSeparator?: boolean
}

const InputDecimal3: FC<InputDecimal3Properties & InputParameters> = ({
    showThousandSeparator = false, ...others
}) => {

    const _props: any = { ...others }

    return (
        <TextField
            fullWidth
            variant={"outlined"}
            size={"small"}
            {..._props}
            label={others.label}
            InputLabelProps={{
                shrink: true,
            }}
            InputProps={{
                ...(others?.InputProps || {}),
                inputComponent: NumberFormatCustom as any,
                endAdornment: others.sufix ? others.sufix : null,
                startAdornment: others.prefix ? others.prefix : null,
                inputProps: {
                    allowNegative: others.allowNegative,
                    decimal: others.decimal,
                    maxLength: others.maxLength,
                    minLength: others.minLength,
                    showThousandSeparator,
                },
            }}
            sufix={others.sufix as any}
        />
    );
}

export { InputDecimal3 }